import { Badge } from '../../../Badge/Badge';

type Props = {
  dataType: string;
  endpoint?: string;
  hasPreset?: boolean;
  small?: boolean;
};

function DataSourceBadge({
  dataType,
  endpoint,
  hasPreset = false,
  small = false,
}: Props) {
  return (
    <Badge variant="green" small={small}>
      {dataType}
      {!hasPreset && endpoint && ` (${endpoint})`}
      {hasPreset && ` «preset»`}
    </Badge>
  );
}

export { DataSourceBadge };
